/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { StaticIntegration } from 'cio/utils/integrations/static-integrations';

interface IntegrationsIconArgs {
  integration: StaticIntegration;
  width?: string;
  height?: string;
}

export default class IntegrationsIcon extends Component<IntegrationsIconArgs> {}
